"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getType = exports.getClickedAttributes = exports.getAttributes = void 0;
var _colors = require("../../tokens/colors");
var getClickedAttr = function getClickedAttr(cbType, color) {
  return _colors.checkboxSelected[cbType](color);
};
var getAttr = function getAttr(disabled, color) {
  return disabled ? _colors.checkbox.disabled : _colors.checkbox["default"](color);
};
var getClickedAttributes = exports.getClickedAttributes = function getClickedAttributes(key) {
  return function (_ref) {
    var cbType = _ref.cbType,
      color = _ref.color;
    return getClickedAttr(cbType, color)[key];
  };
};
var getAttributes = exports.getAttributes = function getAttributes(key) {
  return function (_ref2) {
    var disabled = _ref2.disabled,
      color = _ref2.color;
    return getAttr(disabled, color)[key];
  };
};
var getType = exports.getType = function getType(disabled, solid) {
  var key = [];
  if (disabled) {
    key.push("disabled");
  }
  if (solid) {
    key.push("solid");
  }
  return key.length ? key.join("_") : "default";
};